import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Loading } from 'components';
import PostMessageContext from 'contexts/PostMessage';
import { useQueryInitialState } from 'hooks/useInitialState';

const AppBase: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { i18n } = useTranslation();
  const [{ languageChange }] = useContext(PostMessageContext);
  const { isSuccess, data: initialState } = useQueryInitialState();

  useEffect(() => {
    if (languageChange) {
      i18n.changeLanguage(languageChange);
    }
  }, [i18n, languageChange]);

  useEffect(() => {
    if (initialState) {
      window?.dataLayer?.push({
        merchantId: initialState.merchant.id,
        staffId: initialState.staff.staffId,
      });
    }
  }, [initialState]);

  if (!isSuccess) {
    return <Loading />;
  }
  return <>{children}</>;
};

export default AppBase;
